import { render, staticRenderFns } from "./MaterialsAndTexturesModule.vue?vue&type=template&id=e59e9a86&"
import script from "./MaterialsAndTexturesModule.vue?vue&type=script&lang=js&"
export * from "./MaterialsAndTexturesModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports